export default "__VITE_ASSET__DpEaGGXn__"